import React from 'react';

export const getTagBackgroundColor = (tag, isSelected) => {
    const colorMap = {
        "#shaderGraph": isSelected ? "bg-amber-300" : "bg-amber-100",
        "#python": isSelected ? "bg-blue-300" : "bg-blue-100",
        "#VR": isSelected ? "bg-purple-300" : "bg-purple-100",
        "#3D": isSelected ? "bg-red-300" : "bg-red-100",
        "#firebase": isSelected ? "bg-blue-300" : "bg-blue-100",
        "#UI/UX": isSelected ? "bg-green-300" : "bg-green-100",
        "#CSharp": isSelected ? "bg-blue-300" : "bg-blue-100",
        "#lighting": isSelected ? "bg-orange-300" : "bg-orange-100",
        "#2D": isSelected ? "bg-green-300" : "bg-green-100",
        "#proceduralSystems": isSelected ? "bg-yellow-300" : "bg-yellow-100",
        "#gameplaySystems": isSelected ? "bg-purple-300" : "bg-purple-100",
        "#blenderAPI": isSelected ? "bg-orange-300" : "bg-orange-100",
        "#art": isSelected ? "bg-emerald-300" : "bg-emerald-100",
        "#VFX": isSelected ? "bg-sky-300" : "bg-sky-100",
        "#HTML": isSelected ? "bg-indigo-300" : "bg-indigo-100",
        "#AR": isSelected ? "bg-blue-300" : "bg-blue-100",
        "#android": isSelected ? "bg-cyan-300" : "bg-cyan-100",
        "#webGL": isSelected ? "bg-orange-300" : "bg-orange-100",
        "#behaviourTracking": isSelected ? "bg-teal-300" : "bg-teal-100",
        "#photoshop": isSelected ? "bg-emerald-300" : "bg-emerald-100",
        "#blender": isSelected ? "bg-red-300" : "bg-red-100",
        "#modularDesign": isSelected ? "bg-red-300" : "bg-red-100",
        "#unity": isSelected ? "bg-purple-300" : "bg-purple-100",
        "#post-processing": isSelected ? "bg-orange-300" : "bg-orange-100",
        "#rigging": isSelected ? "bg-rose-300" : "bg-rose-100",
        "#CI/CD": isSelected ? "bg-orange-300" : "bg-orange-100",
    };
    
    return colorMap[tag] || (isSelected ? "bg-gray-400" : "bg-gray-200");
};

export const projects = [
    // The Last Observer
    {
        id: 1,
        slug: "the-last-observer",
        title: "THE LAST OBSERVER",
        description: "Solo-built Unity surveillance simulator: \ncoroutine-optimized multi-camera rendering, real-time NPC navigation, and a custom Blender-to-Unity texture baking pipeline\n\n" + 
        "Built around a core constraint: pure observation gameplay, with no direct character control",
        tags: ["#unity", "#CSharp", "#3D", "#blender", "#gameplaySystems", "#photoshop", "#blenderAPI", "#modularDesign", "#python", "#lighting", "#UI/UX", "#VFX"],
        
        portfolioLayout: {
            type: "two-column",
            columns: [
                {
                    type: "text",
                    width: "w-full lg:w-2/3",
                    content: {
                        showTitle: true,
                        showDescription: true,
                        showTags: true
                    }
                },
                {
                    type: "image",
                    width: "w-full lg:w-1/3",
                    images: [
                        {
                            src: "/images/projects/the-last-observer/preview.gif",
                            srcWebm: "/images/projects/the-last-observer/preview.webm",
                            srcMp4: "/images/projects/the-last-observer/preview.mp4",
                            poster: "/images/projects/the-last-observer/preview_poster.jpg",
                            alt: "The Last Observer gameplay demo"
                        }
                    ]
                }
            ]
        },
        
        projectPageContent: [
            {
                type: "image-gallery",
                images: [
                    {
                        src: "/images/projects/the-last-observer/panopticon_fpv.png",
                        alt: "gameplay_sample"
                    },
                    {
                        src: "/images/projects/the-last-observer/panopticon_scene.png",
                        alt: "gameplay_sample"
                    },
                    {
                        src: "/images/projects/the-last-observer/prisoner_model.png",
                        alt: "gameplay_sample"
                    },
                    {
                        src: "/images/projects/the-last-observer/grid_view.png",
                        alt: "gameplay_sample"
                    },
                    {
                        src: "/images/projects/the-last-observer/detail_view_1.png",
                        alt: "gameplay_sample"
                    },
                    {
                        src: "/images/projects/the-last-observer/detail_view_2.png",
                        alt: "gameplay_sample"
                    },
                ]
            },
            
            // Core Game Loop
            {
                type: "two-column",
                columns: [
                    {
                        type: 'text',
                        width: 'w-full lg:w-1/3',
                        lines: [
                            {
                                content: 'Core gameplay was intentionally scoped to explore player cognition and information overload. ' +
                                'Interaction occurs exclusively through UI, map, and observation - no direct character control',
                                fontSize: 'text-xl',
                                color: 'rgb(93, 93, 93)',
                                marginTop: '24px',
                                marginBottom: '24px',
                                alignment: 'left'
                            },
                            {
                                content: 'Solo project Role: ',
                                fontSize: 'text-xl',
                                color: 'rgb(0, 0, 0)',
                                marginBottom: '0px',
                                alignment: 'left'
                            },
                            {
                                content: 'Programmer, 3D Artist, Game Designer',
                                fontSize: 'text-xl',
                                color: 'rgb(0, 0, 0)',
                                alignment: 'left'
                            },
                            
                        ]
                    },
                    {
                        type: 'image',
                        width: 'w-full lg:w-2/3',
                        position: 'right',
                        bgColor: 'bg-white',
                        images: [
                            {
                                src: 'images/projects/the-last-observer/game_core_loop_diagram.png',
                                alt: 'game_core_loop_diagram.png'
                            }
                        ]
                    }
                ]
            },
            // Technical Solutions Title
            {
                type: "text",
                content: "TECHNICAL SOLUTIONS",
                alignment: "left",
                fontSize: "text-3xl",
                color: "#59cbff",
                marginBottom: 'mb-2'
            },
            // Camera System 
            {
                type: "two-column",
                columns: [
                    {
                        type: 'text',
                        width: 'w-full lg:w-1/2',
                        lines: [
                            {
                                content: 'CAMERA SYSTEM',
                                fontSize: 'text-2xl',
                                color: "#6fb2ff",
                                alignment: 'left',
                                marginBottom: '0px'
                            },
                            {
                                content: 'The surveillance system consists of multiple cameras that can be viewed either in a grid overview or as a focused single feed. ' +
                                'Players can dynamically switch between cameras to monitor different areas and track NPC movement in real time',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                            {
                                content: 'Each camera is a separate GameObject with RenderTexture',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                            {
                                content: 'To optimize performance, camera updates are controlled via a coroutine-based system, ' +
                                ' and cameras that are not currently active are disabled to reduce rendering overhead. This approach allows efficient scaling while maintaining responsive monitoring',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            }
                        ]
                    },
                    {
                        type: 'image',
                        width: 'w-full lg:w-1/2',
                        position: 'right',
                        images: [
                            {
                                src: 'images/projects/the-last-observer/camera_system.gif',
                                srcWebm: 'images/projects/the-last-observer/camera_system.webm',
                                srcMp4: 'images/projects/the-last-observer/camera_system.mp4',
                                poster: 'images/projects/the-last-observer/camera_system_poster.jpg',
                                alt: 'camera_system.gif'
                            }
                        ]
                    },
                ]
            },
            // Blueprint Interactions
            {
                type: "two-column",
                columns: [
                    {
                        type: 'image',
                        width: 'w-full lg:w-1/2',
                        position: 'right',
                        images: [
                            {
                                src: 'images/projects/the-last-observer/blueprint_interactions.gif',
                                srcWebm: 'images/projects/the-last-observer/blueprint_interactions.webm',
                                srcMp4: 'images/projects/the-last-observer/blueprint_interactions.mp4',
                                poster: 'images/projects/the-last-observer/blueprint_interactions_poster.jpg',
                                alt: 'blueprint_interactions.gif'
                            }
                        ]
                    },
                    {
                        type: 'text',
                        width: 'w-full lg:w-1/2',
                        lines: [
                            {
                                content: 'BLUEPRINT INTERACTIONS',
                                fontSize: 'text-2xl',
                                color: "#6fb2ff",
                                alignment: 'left'
                            },
                            {
                                content: 'The player interacts with a multi-floor building blueprint in real time: ' +
                                'drawing directly over the plan to mark suspected NPC routes, open and closed passages, dangerous areas, and personal notes.',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                            {
                                content: 'Each floor has its own independent layer of user annotations. All markings are preserved when switching between floors.',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left',
                                marginBottom: '32px'
                            },
                            {
                                content: 'The system is implemented as an interactive drawing surface within the UI and functions as an analytical gameplay tool rather than a decorative element.',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                        ]
                    }
                ]
            },
            //Surveillance System Architecture Overview
            {
                type: "text",
                content: "SURVEILLANCE SYSTEM ARCHITECTURE OVERVIEW",
                alignment: "left",
                fontSize: 'text-3xl',
                color: "#6fb2ff",
                marginBottom: 'mb-2'
            },
            {
                type: "hero-image",
                src: "images/projects/the-last-observer/architecture_overview.png",
                alt: "architecture_overview.png"
            },
            // NPC Navigation & Interaction
            {
                type: "two-column",
                columns: [
                    {
                        type: 'text',
                        width: 'w-full lg:w-1/2',
                        lines: [
                            {
                                content: 'NPC NAVIGATION & INTERACTION',
                                fontSize: 'text-2xl',
                                color: "#6fb2ff",
                                alignment: 'left'
                            },
                            {
                                content: 'NPCs are the primary source of pressure in the game, creating constant tension through unpredictable movement and interactions with the environment.'+
                                'They navigate between rooms, operate doors, and can change map states - for example, opening previously closed passages',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                            {
                                content: 'Their behavior forces the player to interpret incomplete information and make decisions under pressure, making NPC activity the core driver of threat escalation rather than background simulation',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left',
                                marginBottom: '32px'
                            }
                        ]
                    },
                    {
                        type: 'image',
                        width: 'w-full lg:w-1/2',
                        position: 'right',
                        images: [
                            {
                                src: 'images/projects/the-last-observer/npc_navigation.gif',
                                srcWebm: 'images/projects/the-last-observer/npc_navigation.webm',
                                srcMp4: 'images/projects/the-last-observer/npc_navigation.mp4',
                                poster: 'images/projects/the-last-observer/npc_navigation_poster.jpg',
                                alt: 'npc_navigation.gif'
                            }
                        ]
                    }
                ]
            },
            // Tools & Pipeline Engineering
            {
                type: "text",
                content: "TOOLS & PIPELINE ENGINEERING",
                alignment: "right",
                fontSize: "text-3xl",
                color: "#59cbff",
                marginBottom: 'mb-2'
            },
            {
                type: "two-column",
                columns: [
                    {
                        type: 'image',
                        width: 'w-full lg:w-1/2',
                        position: 'right',
                        images: [
                            {
                                src: 'images/projects/the-last-observer/blender_unity_texture_pipeline.gif',
                                srcWebm: 'images/projects/the-last-observer/blender_unity_texture_pipeline.webm',
                                srcMp4: 'images/projects/the-last-observer/blender_unity_texture_pipeline.mp4',
                                poster: 'images/projects/the-last-observer/blender_unity_texture_pipeline_poster.jpg',
                                alt: 'Blender → Unity Texture Pipeline.png'
                            }
                        ]
                    },
                    {
                        type: 'text',
                        width: 'w-full lg:w-1/2',
                        lines: [
                            {
                                content: 'TEXTURE BAKING & UNITY INTEGRATION PIPELINE',
                                fontSize: 'text-2xl',
                                color: "#6fb2ff",
                                alignment: 'left'
                            },
                            {
                                content: 'The tool automates the workflow of converting procedural Blender materials into production-ready Unity textures and materials.' +
                                'It includes a Blender addon for baking Albedo, Normal, and packed MRAO maps, along with a Unity import pipeline that automatically configures texture settings, compression, and material parameters',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                            {
                                content: 'By integrating baking, export, and engine import into a single pipeline, the tool reduces manual setup time, prevents configuration errors, and ensures consistent visual results across assets',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                        ]
                    }
                ]
            },
            {
                type: "text",
                content: [
                    {
                        type: "text",
                        text: "View the standalone tool:  "
                    },
                    {
                        type: "link",
                        text: "blender_unity_baker",
                        href: "https://github.com/khazanovanastasia/blender-addons/tree/main/blender_unity_baker",
                        color: "#6fb2ff"
                    }
                ],
                fontSize: 'text-xl',
                alignment: 'right',
                marginBottom: 'mb-12'
                
            },
            // Github link
            {
                type: "github-link",
                url: "https://github.com/khazanovanastasia/The-Last-Observer",
                text: "View source code on GitHub",
                alignment: "center"
            },
            /*
            {
                type: "itchio-link",
                url: "https://yourusername.itch.io/your-game",
                text: "Play Now",
                alignment: "center"
            },*/
        ]
    },
    // Green Square
    {
        id: 2,
        slug: "green-square",
        title: "GREEN SQUARE",
        description: "Interactive art installation built solo end-to-end across three stacks - a Unity real-time renderer, a mobile web front-end, and Firebase as the sync layer - so visitor uploads propagate live into a running Unity scene as a continuous, self-built content pipeline\n\n" +
        "Taken from concept through to a public exhibition at Kunsthalle №7, Saint-Petersburg",
        tags: ["#firebase", "#unity", "#HTML", "#CSharp", "#android", "#photoshop", "#web"],
        
        portfolioLayout: {
            type: "two-column",
            columns: [
                {
                    type: "image",
                    width: "w-full lg:w-1/3",
                    images: [
                        {
                            src: "/images/projects/green-square/preview.gif",
                            srcWebm: "/images/projects/green-square/preview.webm",
                            srcMp4: "/images/projects/green-square/preview.mp4",
                            poster: "/images/projects/green-square/preview_poster.jpg",
                            alt: "Green Square preview"
                        }
                    ]
                },
                {
                    type: "text",
                    width: "w-full lg:w-2/3",
                    content: {
                        showTitle: true,
                        showDescription: true,
                        showTags: true
                    }
                }
            ]
        },
        
        projectPageContent: [
        
            {
                type: "two-column",
                columns: [
                    {
                        type: 'text',
                        width: 'w-full lg:w-1/2',
                        lines: [
                            {
                                content: 'Green Square is an interactive digital installation exploring authorship, mediation, and participatory image culture through a reinterpretation of Kazimir Malevich’s iconic square. A bright chroma-green square is projected in physical space and periodically replaced with images submitted by visitors, transforming the artwork into a continuously evolving collective surface',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                            {
                                content: 'The installation was exhibited at Kunsthalle №7 in Saint-Petersburg',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                        ]
                    },
                    {
                        type: 'image',
                        width: 'w-full lg:w-1/2',
                        position: 'right',
                        images: [
                            {
                                src: '/images/projects/green-square/preview.gif',
                                srcWebm: '/images/projects/green-square/preview.webm',
                                srcMp4: '/images/projects/green-square/preview.mp4',
                                poster: '/images/projects/green-square/preview_poster.jpg',
                                alt: 'green-square.gif'
                            }
                        ]
                    },
                ]
            },
            {
                type: "text",
                content: 'Technically, the system integrates a web interface, cloud storage, and a Unity application into a real-time content pipeline. Visitors scan a QR code to access a mobile webpage, upload an image, and the file is immediately synchronized with the running Unity scene, where it replaces the projected texture. The project combines frontend development, backend integration, and real-time rendering, demonstrating cross-platform interaction between audience devices and an installation environment',
                fontSize: 'text-xl',
                                color: "#595959",                
            },
            {
                type: "text",
                content: 'The entire system - including the website, Unity application, visual setup, and deployment - was developed independently',
                fontSize: 'text-xl',
                                color: "#595959",                
            },
        ]
    },
    // Drift Remains
    {
        id: 3,
        slug: "drift-remains",
        title: "DRIFT REMAINS",
        description: "Solo-built survival game driven by an event-based world-decay architecture\n\nA custom behaviour-tracking system silently records rhythm, drift resistance, and anomaly engagement, then converts that telemetry into a runtime-generated player report at session end",
        tags: ["#unity", "#CSharp", "#3D", "#blender", "#gameplaySystems", "#proceduralSystems", "#behaviourTracking", "#webGL", "#CI/CD", "#VFX"],

        portfolioLayout: {
            type: "two-column",
            columns: [
                {
                    type: "text",
                    width: "w-full lg:w-2/3",
                    content: {
                        showTitle: true,
                        showDescription: true,
                        showTags: true
                    }
                },
                {
                    type: "image",
                    width: "w-full lg:w-1/3",
                    images: [
                        {
                            src: "/images/projects/drift-remains/preview.gif",
                            srcWebm: "/images/projects/drift-remains/preview.webm",
                            srcMp4: "/images/projects/drift-remains/preview.mp4",
                            poster: "/images/projects/drift-remains/preview_poster.jpg",
                            alt: "Drift Remains gameplay demo"
                        }
                    ]
                }
            ]
        },

        projectPageContent: [
            /*Image gallery
            {
                type: "image-gallery",
                images: [
                    {
                        src: "/images/projects/drift-remains/gameplay_sample.png",
                        alt: "gameplay_sample"
                    },
                    {
                        src: "/images/projects/drift-remains/gameplay_sample.png",
                        alt: "gameplay_sample"
                    },
                    {
                        src: "/images/projects/drift-remains/gameplay_sample.png",
                        alt: "gameplay_sample"
                    },
                    {
                        src: "/images/projects/drift-remains/gameplay_sample.png",
                        alt: "gameplay_sample"
                    },
                    {
                        src: "/images/projects/drift-remains/gameplay_sample.png",
                        alt: "gameplay_sample"
                    },
                    {
                        src: "/images/projects/drift-remains/gameplay_sample.png",
                        alt: "gameplay_sample"
                    },
                ]
            },
            */
           
            // Core Game Loop
            {
                type: "two-column",
                columns: [
                    {
                        type: 'text',
                        width: 'w-full lg:w-1/1',
                        lines: [
                            {
                                content: 'The game strips away explicit goals. The only input is rowing - left oar, right oar. ' +
                                'Everything else - decay, anomalies, drift - happens to the player, not because of them. ' +
                                'The tension comes from deciding how to respond',
                                fontSize: 'text-xl',
                                color: 'rgb(93, 93, 93)',
                                marginTop: '0px',
                                marginBottom: '24px',
                                alignment: 'left'
                            },
                            {
                                content: 'Solo project Role: ',
                                fontSize: 'text-xl',
                                color: 'rgb(0, 0, 0)',
                                marginBottom: '0px',
                                alignment: 'left'
                            },
                            {
                                content: 'Programmer, 3D Artist, Game Designer',
                                fontSize: 'text-xl',
                                color: 'rgb(0, 0, 0)',
                                alignment: 'left'
                            },
                        ]
                    }
                ]
            },
            // Technical Solutions Title
            {
                type: "text",
                content: "TECHNICAL SOLUTIONS",
                alignment: "left",
                fontSize: "text-3xl",
                color: "#59cbff",
                marginBottom: 'mb-2'
            },
            // World Decay System
            {
                type: "two-column",
                columns: [
                    {
                        type: 'text',
                        width: 'w-full lg:w-1/2',
                        lines: [
                            {
                                content: 'WORLD DECAY SYSTEM',
                                fontSize: 'text-2xl',
                                color: "#6fb2ff",
                                alignment: 'left',
                                marginBottom: '0px'
                            },
                            {
                                content: 'The world degrades continuously over a fixed session duration, driven by a single normalised decay value (0–1) inside WorldDecayController. ' +
                                'Every other system subscribes to it via events, with no knowledge of each other',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                            {
                                content: 'That one value reaches almost everything: waves grow heavier, the current and rain intensify, ' +
                                "colours shift toward black, and the music degrades. " +
                                "Fixed thresholds also step the world into new phases, changing the raft's condition, log phrasing, and the appearance of anomalies",
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            }
                        ]
                    },
                    {
                        type: 'image',
                        width: 'w-full lg:w-1/2',
                        position: 'right',
                        images: [
                            {
                                src: 'images/projects/drift-remains/world_decay.gif',
                                srcWebm: 'images/projects/drift-remains/world_decay.webm',
                                srcMp4: 'images/projects/drift-remains/world_decay.mp4',
                                poster: 'images/projects/drift-remains/world_decay_poster.jpg',
                                alt: 'world_decay.gif'
                            }
                        ]
                    },
                ]
            },
            // Behaviour Tracker & Log Systen
            {
                type: "two-column",
                columns: [
                    {
                        type: 'image',
                        width: 'w-full lg:w-1/2',
                        position: 'right',
                        images: [
                            {
                                src: 'images/projects/drift-remains/behaviour_report.gif',
                                srcWebm: 'images/projects/drift-remains/behaviour_report.webm',
                                srcMp4: 'images/projects/drift-remains/behaviour_report.mp4',
                                poster: 'images/projects/drift-remains/behaviour_report_poster.jpg',
                                alt: 'behaviour_report.gif'
                            }
                        ]
                    },
                    {
                        type: 'text',
                        width: 'w-full lg:w-1/2',
                        lines: [
                            {
                                content: 'BEHAVIOUR TRACKER & LOG SYSTEM',
                                fontSize: 'text-2xl',
                                color: "#6fb2ff",
                                alignment: 'left'
                            },
                            {
                                content: 'Throughout the session, BehaviourTracker silently records metrics: ' +
                                'camera variance, movement rhythm, drift resistance, plank collection, anomaly engagement, and adaptation speed after a control inversion',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                            {
                                content: 'That telemetry surfaces live through LogSystem - a diegetic, phase-aware text stream typed word by word and colour-coded by category, ' +
                                'stored bilingually (EN / RU) and resolved at runtime ',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left',
                            },
                            {
                                content: 'At session end, ReportGenerator compares each metric against thresholds and assembles a unique psychological profile from randomised observation lines',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left',
                                marginBottom: '0px'
                            }
                        ]
                    }
                ]
            },
            // Raft Physics & Wave Integration
            {
                type: "two-column",
                columns: [
                    {
                        type: 'text',
                        width: 'w-full lg:w-1/2',
                        lines: [
                            {
                                content: 'RAFT PHYSICS & WAVE INTEGRATION',
                                fontSize: 'text-2xl',
                                color: "#6fb2ff",
                                alignment: 'left'
                            },
                            {
                                content: 'The raft is a Rigidbody that is repositioned each FixedUpdate to match procedural wave height sampled at its position. ' +
                                'Tilt and roll are calculated from height differences at four surrounding sample points, ' +
                                'producing natural bobbing that intensifies as wave amplitude increases with decay',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                            {
                                content: 'Rowing applies directional force and torque using only two keys (A / D). ' +
                                'Keystroke intervals are captured in real time and fed to BehaviourTracker to measure rhythm. ' +
                                'A control inversion flag - set mid-session - reverses all input and triggers adaptation measurement',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            }
                        ]
                    },
                    {
                        type: 'image',
                        width: 'w-full lg:w-1/2',
                        position: 'right',
                        images: [
                            {
                                src: 'images/projects/drift-remains/raft_physics.gif',
                                srcWebm: 'images/projects/drift-remains/raft_physics.webm',
                                srcMp4: 'images/projects/drift-remains/raft_physics.mp4',
                                poster: 'images/projects/drift-remains/raft_physics_poster.jpg',
                                alt: 'raft_physics.gif'
                            }
                        ]
                    }
                ]
            },
            // Github link
            {
                type: "github-link",
                url: "https://github.com/khazanovanastasia/drift-remains",
                text: "View source code on GitHub",
                alignment: "center"
            },
            // Itch link
            {
                type: "itchio-link",
                url: "https://khazanovanastasia.itch.io/drift-remains",
                text: "Play on itch.io",
                alignment: "center"
            }
        ]
    },
    // Pipeline & Tools Development
    {
        id: 4,
        slug: "pipeline-and-tools",
        title: "PIPELINE & TOOLS DEVELOPMENT",
        description: "Three Python/Blender-API tools built to remove manual steps from an art-to-engine pipeline: tiled-texture mixing, unused shader-node detection, Unity-ready texture export pipeline, used to produce the assets of The Last Observer",
        tags: ["#python", "#blender","#blenderAPI", "#CSharp", "#unity", "#3D"],
        
        portfolioLayout: {
            type: "two-column",
            columns: [
                {
                    type: "image",
                    width: "w-full lg:w-1/3",
                    images: [
                        {
                            src: "images/projects/the-last-observer/blender_unity_texture_pipeline.gif",
                            srcWebm: "images/projects/the-last-observer/blender_unity_texture_pipeline.webm",
                            srcMp4: "images/projects/the-last-observer/blender_unity_texture_pipeline.mp4",
                            poster: "images/projects/the-last-observer/blender_unity_texture_pipeline_poster.jpg",
                            alt: "blender-addons preview"
                        }
                    ]
                },
                {
                    type: "text",
                    width: "w-full lg:w-2/3",
                    content: {
                        showTitle: true,
                        showDescription: true,
                        showTags: true
                    }
                },
            ]
        },
        
        projectPageContent: [
            // Blender-Unity Baker
            {
                type: "two-column",
                columns: [
                    {
                        type: 'image',
                        width: 'w-full lg:w-1/2',
                        position: 'right',
                        images: [
                            {
                                src: 'images/projects/the-last-observer/blender_unity_texture_pipeline.gif',
                                srcWebm: 'images/projects/the-last-observer/blender_unity_texture_pipeline.webm',
                                srcMp4: 'images/projects/the-last-observer/blender_unity_texture_pipeline.mp4',
                                poster: 'images/projects/the-last-observer/blender_unity_texture_pipeline_poster.jpg',
                                alt: 'Blender → Unity Texture Pipeline.png'
                            }
                        ]
                    },
                    {
                        type: 'text',
                        width: 'w-full lg:w-1/2',
                        lines: [
                            {
                                content: 'BLENDER → UNITY BAKER',
                                fontSize: 'text-2xl',
                                color: "#6fb2ff",
                                alignment: 'left'
                            },
                            {
                                content: 'The tool automates the workflow of converting procedural Blender materials into production-ready Unity textures and materials.' +
                                'It includes a Blender addon for baking Albedo, Normal, and packed MRAO maps, along with a Unity import pipeline that automatically configures texture settings, compression, and material parameters',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                            {
                                content: 'By integrating baking, export, and engine import into a single pipeline, the tool reduces manual setup time, prevents configuration errors, and ensures consistent visual results across assets',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                        ]
                    }
                ]
            },

            // Tiled textures mixer
            {
                type: "two-column",
                columns: [
                    {
                        type: 'text',
                        width: 'w-full lg:w-2/3',
                        lines: [
                            {
                                content: 'TILED TEXTURES MIXER',
                                fontSize: 'text-2xl',
                                color: "#6fb2ff",
                                alignment: 'left'
                            },
                            {
                                content: 'A Blender addon that replaces manual shader-node wiring with a one-click, mask-driven blend system. ' +
                                'It procedurally builds a full PBR node graph - texture coordinates, UV mapping, and a chain of Mix RGB nodes - that blends up to 4 tiled texture sets across a surface, using the RGB channels of a mask texture as a splat map',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                            {
                                content: 'Metallic and Roughness are packed into the alpha channels of the tile textures, keeping texture count down without sacrificing material fidelity. ' +
                                'What would normally take dozens of manually wired nodes per material is generated correctly every time, removing a repetitive, error-prone step from environment production',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            }
                        ]
                    },
                    {
                        type: 'image',
                        width: 'w-full lg:w-1/3',
                        position: 'right',
                        images: [
                            {
                                src: '/images/projects/blender-addons/tiled-textures-mixer.gif',
                                srcWebm: '/images/projects/blender-addons/tiled-textures-mixer.webm',
                                srcMp4: '/images/projects/blender-addons/tiled-textures-mixer.mp4',
                                poster: '/images/projects/blender-addons/tiled-textures-mixer_poster.jpg',
                                alt: 'Tiled Textures Mixer'
                            }
                        ]
                    }
                ]
            },

             // Unused nodes finder
            {
                type: "two-column",
                columns: [
                    {
                        type: 'image',
                        width: 'w-full lg:w-1/3',
                        position: 'left',
                        images: [
                            {
                                src: '/images/projects/blender-addons/unused-nodes-finder.gif',
                                srcWebm: '/images/projects/blender-addons/unused-nodes-finder.webm',
                                srcMp4: '/images/projects/blender-addons/unused-nodes-finder.mp4',
                                poster: '/images/projects/blender-addons/unused-nodes-finder_poster.jpg',
                                alt: 'Unused nodes finder'
                            }
                        ]
                    },
                    {
                        type: 'text',
                        width: 'w-full lg:w-2/3',
                        lines: [
                            {
                                content: 'UNUSED NODES FINDER',
                                fontSize: 'text-2xl',
                                color: "#6fb2ff",
                                alignment: 'left'
                            },
                            {
                                content: 'A Blender addon that keeps shared production materials clean by walking every material\'s node graph backward from the Material Output - including recursively through nested node groups - to find nodes that contribute nothing to the final result',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                            {
                                content: 'Instead of just reporting a list, it flags each unused node directly in the Shader Editor and organizes them into a labeled frame, so artists can review and clean them up at a glance. ' +
                                'On a team where materials are shared and iterated on by multiple people, this catches the small leftovers that quietly bloat shader complexity over time',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            }
                        ]
                    }
                ]
            },
            {
                type: "github-link",
                url: "https://github.com/khazanovanastasia/blender-addons",
                text: "View on GitHub",
                alignment: "center"
            }
        ]
    },
    // VR Shooting Training
    {
        id: 5,
        slug: "vr-shooting-training",
        title: "VR SHOOTING TRAINING",
        description: "Commercial VR training simulator \n\nBuilt lightweight, reusable UI animation components (Shapes + LeanTween) integrated into an existing production architecture as a Technical Artist Intern",
        tags: ["#unity", "#CSharp", "#3D", "#UI/UX", "#VR"],
        
        portfolioLayout: {
            type: "two-column",
            columns: [
                {
                    type: "text",
                    width: "w-full lg:w-2/3",
                    content: {
                        showTitle: true,
                        showDescription: true,
                        showTags: true
                    }
                },
                {
                    type: "image",
                    width: "w-full lg:w-1/3",
                    images: [
                        {
                            src: "/images/projects/vr-shooting/preview.gif",
                            srcWebm: "/images/projects/vr-shooting/preview.webm",
                            srcMp4: "/images/projects/vr-shooting/preview.mp4",
                            poster: "/images/projects/vr-shooting/preview_poster.jpg",
                            alt: "VR Shooting Training preview"
                        }
                    ]
                }
            ]
        },
        
         projectPageContent: [
            // Intro / role
            {
                type: "two-column",
                columns: [
                    {
                        type: 'text',
                        width: 'w-full lg:w-1/2',
                        lines: [
                            {
                                content: "Commercial VR shooting training simulator, developed by a Unity studio in a real production team." ,
                                fontSize: 'text-xl',
                                color: 'rgb(93, 93, 93)',
                                marginTop: '24px',
                                alignment: 'left'
                            },
                            {
                                content: "Role: Technical Artist Intern, working directly with the lead Technical Artist and the Unity programmer on the visual side of the product",
                                fontSize: 'text-xl',
                                color: 'rgb(93, 93, 93)',
                                marginBottom: '24px',
                                alignment: 'left'
                            },
                            {
                                content: 'Process: Git, task tracking, code review, daily sync with the Technical Artist - working inside an existing codebase and existing assets rather than building from scratch',
                                fontSize: 'text-xl',
                                color: 'rgb(0, 0, 0)',
                                alignment: 'left'
                            }
                        ]
                    },
                    {
                        type: 'image',
                        width: 'w-full lg:w-1/2',
                        position: 'right',
                        images: [
                            {
                                src: '/images/projects/vr-shooting/preview.gif',
                                srcWebm: '/images/projects/vr-shooting/preview.webm',
                                srcMp4: '/images/projects/vr-shooting/preview.mp4',
                                poster: '/images/projects/vr-shooting/preview_poster.jpg',
                                alt: 'team_process.png'
                            }
                        ]
                    }
                ]
            },
            // Technical Solutions Title
            {
                type: "text",
                content: "TECHNICAL SOLUTIONS",
                alignment: "left",
                fontSize: "text-3xl",
                color: "#59cbff",
                marginBottom: 'mb-2'
            },
            //Shapes + LeanTween 
            {
                type: "text",
                content: 'SHAPES + LEANTWEEN',
                fontSize: 'text-2xl',
                color: "#6fb2ff",
                alignment: 'left',
                marginBottom: '0px'
            },
            {
                type: "text",
                content: 'VR renders at a fixed high frame rate to avoid motion sickness, so every UI update has to be cheap and predictable. ' +
                'Animator Controllers add state-machine overhead and are awkward to reuse across differently-shaped UI elements',
                fontSize: 'text-xl',
                color: "#595959",
                alignment: 'left',
                marginBottom: 'mb-2'
            },
            {
                type: "text",
                content: 'Shapes was used to draw and redraw UI geometry procedurally, and LeanTween to drive lightweight, code-first tweens - ' +
                'together they let animated UI be shipped as reusable components instead of one-off timelines',
                fontSize: 'text-xl',
                color: "#595959",
                alignment: 'left',
                marginBottom: 'mb-2'
            },
            // Reusable components / integration
            {
                type: "text",
                content: 'REUSABLE, ARCHITECTURE-SAFE UI',
                fontSize: 'text-2xl',
                color: "#6fb2ff",
                alignment: 'left',
                marginBottom: '0px'
            },
            {
                type: "text",
                content: 'UI transitions were built as reusable animation components rather than scene-specific effects, ' +
                'so the same building blocks could be reapplied to future interface work without rewriting logic',
                fontSize: 'text-xl',
                color: "#595959",
                alignment: 'left',
                marginBottom: 'mb-2'
            },
            {
                type: "text",
                content: 'New UI elements, transitions and adjusted interaction logic were integrated into the existing project architecture ' +
                'without restructuring it - alongside 3D model integration, particle systems, colliders and asset optimization to keep the project consistent',
                fontSize: 'text-xl',
                color: "#595959",
                alignment: 'left',
                marginBottom: 'mb-8'
            },
            // What it demonstrates
            {
                type: "text",
                content: "Working inside a live production pipeline - shipping features into someone else's architecture, under code review, without breaking existing systems - is a different skill from building a project solo, and this is where that skill was built",
                fontSize: "text-xl",
                color: "rgb(93, 93, 93)",
                alignment: "left",
            }
        ]
    },
    // Harry Houdini
    {
        id: 6,
        slug: "harry-houdini",
        title: "HARRY HOUDINI",
        description: "A custom Shader Graph water shader driven entirely by cursor velocity \n\nNo simulated geometry, just mask-based distortion, ripple amplitude and decay computed in real time and fed by a C# input script",
        tags: ["#unity", "#CSharp", "#3D", "#VFX", "#blender", "#shaderGraph", "#rigging", "#webGL"],
        
        portfolioLayout: {
            type: "two-column",
            columns: [
                {
                    type: "image",
                    width: "w-full lg:w-1/3",
                    images: [
                        {
                            src: "/images/projects/harry-houdini/preview.gif",
                            srcWebm: "/images/projects/harry-houdini/preview.webm",
                            srcMp4: "/images/projects/harry-houdini/preview.mp4",
                            poster: "/images/projects/harry-houdini/preview_poster.jpg",
                            alt: "Harry Houdini preview"
                        }
                    ]
                },
                {
                    type: "text",
                    width: "w-full lg:w-2/3",
                    content: {
                        showTitle: true,
                        showDescription: true,
                        showTags: true
                    }
                }
            ]
        },
        
        projectPageContent: [
            // Shader breakdown
            {
                type: "two-column",
                    columns: [
                    {
                        type: 'text',
                        width: 'w-full lg:w-1/2',
                        lines: [
                            {
                                content: 'WATER SHADER (SHADER GRAPH)',
                                fontSize: 'text-2xl',
                                color: "#6fb2ff",
                                alignment: 'left',
                                marginBottom: '0px'
                            },
                            {
                                content: 'The water surface is not simulated geometry - it is a single Shader Graph that fakes fluid behavior entirely through masking and distortion',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                            {
                                content: 'A mask splits the surface into transparent and opaque regions; direction distortion is driven by the cursor-to-center vector, ' +
                                'ripple amplitude scales with cursor speed, and ripples decay over time to settle back to rest',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                            {
                                content: 'Shader parameters are exposed for tuning, so the behavior can be adjusted without touching the graph itself',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            }
                        ]
                    },
                    {
                        type: "image",
                        width: "w-full lg:w-1/2",
                        images: [
                            {
                                src: "/images/projects/harry-houdini/preview.gif",
                                srcWebm: "/images/projects/harry-houdini/preview.webm",
                                srcMp4: "/images/projects/harry-houdini/preview.mp4",
                                poster: "/images/projects/harry-houdini/preview_poster.jpg",
                                alt: "Harry Houdini preview"
                            }
                        ]
                    }
                ]
            },
            // Pivot Controller
            {
                type: "two-column",
                columns: [
                    
                    {
                        type: 'text',
                        width: 'w-full lg:w-1/1',
                        lines: [
                            {
                                content: 'C# TO SHADER PIPELINE',
                                fontSize: 'text-2xl',
                                color: "#6fb2ff",
                                alignment: 'left',
                                marginBottom: '0px'
                            },
                            {
                                content: 'PivotController.cs tracks cursor position relative to the cube center each frame, computes direction and velocity, ' +
                                'normalizes both and feeds them into the shader as material parameters - a small, self-contained bridge between input and Shader Graph',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                            {
                                content: 'Character and container models were sculpted and textured in Blender and kept deliberately simple, ' +
                                'so the distortion driven by the shader stays the visual focus of the piece',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            }
                        ]
                    }
                ]
            },
            {
                type: "webgl",
                buildPath: "/webgl-builds/harry-houdini",
                buildName: "harry-houdini",
                compression: "br",  
                width: "100%",
                height: "600px",
                mobileFallback: {
                    src: "/images/projects/harry-houdini/preview.gif",
                    srcWebm: "/images/projects/harry-houdini/preview.webm",
                    srcMp4: "/images/projects/harry-houdini/preview.mp4",
                    poster: "/images/projects/harry-houdini/preview_poster.jpg",
                    alt: "harry-houdini preview"
                }
            },
            {
                type: "github-link",
                url: "https://github.com/khazanovanastasia/harry-houdini-water-shader", 
                text: "View Project on GitHub",
                alignment: "center"
            },
        ]
    },
    // Procedural Light and Blur
    {
        id: 7,
        slug: "procedural-light-and-blur",
        title: "PROCEDURAL LIGHT AND BLUR",
        description: "A runtime visual effect: light and translucent blur shapes drift across the scene with randomized motion, tuned live through user-facing sliders",
        tags: ["#unity", "#CSharp", "#3D", "#proceduralSystems", "#photoshop"],
        
        portfolioLayout: { 
            type: "two-column",
            columns: [
                
                {
                    type: "text",
                    width: "w-full lg:w-2/3",
                    content: {
                        showTitle: true,
                        showDescription: true,
                        showTags: true
                    }
                },
                {
                    type: "image",
                    width: "w-full lg:w-1/3",
                    images: [
                        {
                            src: "/images/projects/procedural-light/preview.gif",
                            srcWebm: "/images/projects/procedural-light/preview.webm",
                            srcMp4: "/images/projects/procedural-light/preview.mp4",
                            poster: "/images/projects/procedural-light/preview_poster.jpg",
                            alt: "Procedural Light and Blur preview"
                        }
                    ]
                }
            ]
        },
        
        projectPageContent: [
            {
                type: "local-video",
                src: "/video/procedural-light-and-blur-demo.mp4",
                title: "Procedural Light and Blur Demo" 
            }
        ]
    },
    
    //#region non-included
    // Star Delivery Boy
    /*
    {
        id: 4,
        slug: "star-delivery-boy",
        title: "STAR DELIVERY BOY",
        description: "Survival game built around day-based progression and resource management.\n\nThe player prepares equipment at home, explores procedurally generated city blocks, distributes contraband, manages addiction and basic needs, and attempts to survive an increasingly difficult run while maintaining financial stability.",
        tags: ["#unity", "#CSharp", "#2D", "#2DArt", "#aseprite", "#proceduralGeneration", "#game", "#gameplaySystems", "#shaderGraph"],
        
        portfolioLayout: {
            type: "two-column",
            columns: [
                {
                    type: "image",
                    width: "w-full lg:w-1/3",
                    images: [
                        {
                            src: "/images/projects/star-delivery-boy/preview.gif",
                            alt: "Star Delivery Boy gameplay demo"
                        }
                    ]
                },
                {
                    type: "text",
                    width: "w-full lg:w-2/3",
                    content: {
                        showTitle: true,
                        showDescription: true,
                        showTags: true
                    }
                }
            ]
        },
        
        projectPageContent: 
        [ 
            // Project Overview
            
            { 
                type: "two-column", 
                columns: [ 
                    { 
                        type: "text", 
                        width: "w-full lg:w-1/3", 
                        content: { 
                            showTitle: false 
                        }, 
                        lines: [ 
                            { 
                                content: 
                                "The design is built around four interlocking systems:"         
                                , 
                                fontSize: "text-xl", 
                                color: "rgb(93, 93, 93)", 
                                marginTop: "8px", 
                                marginBottom: "24px", 
                                alignment: "left" 
                            }, 
                            { 
                                content: "- day cycle that frames every session;", 
                                fontSize: "text-xl", 
                                color: "rgb(93, 93, 93)", 
                                marginBottom: "10px", 
                                marginLeft: "16px", 
                                alignment: "left" 
                            }, 
                            { 
                                content: 
                                "- needs and stats system that ties the character's physical and mental state to gameplay outcomes;",
                                fontSize: "text-xl", 
                                color: "rgb(93, 93, 93)", 
                                marginBottom: "10px", 
                                marginLeft: "16px", 
                                alignment: "left" 
                            } , 
                            { 
                                content: 
                                "- procedurally generated world that keeps each day spatially fresh;",
                                fontSize: "text-xl", 
                                color: "rgb(93, 93, 93)", 
                                marginBottom: "10px", 
                                marginLeft: "16px", 
                                alignment: "left" 
                            },
                            { 
                                content: 
                                "- economy loop that gives every decision - what to buy, what to wear, whether to risk one more delivery - " +
                                "a tangible consequence the next morning",
                                fontSize: "text-xl", 
                                color: "rgb(93, 93, 93)", 
                                marginBottom: "20px", 
                                marginLeft: "16px", 
                                alignment: "left" 
                            },
                            { 
                                content: 
                                "All visual assets - characters, clothing items, props, and the tile-based environment art - " +
                                "were designed and drawn by me specifically for this project",
                                fontSize: "text-xl", 
                                color: "rgb(93, 93, 93)", 
                                marginBottom: "10px", 
                                marginLeft: "16px", 
                                alignment: "left" 
                            } 
                        ] 
                    }, 
                    { 
                        type: "image", 
                        width: "w-full lg:w-2/3", 
                        position: "right", 
                        bgColor: "bg-white", 
                        images: 
                        [ 
                            { 
                                src: "images/projects/star-delivery-boy/core_loop_diagram.png", 
                                alt: "core_loop_diagram.png" 
                            } 
                        ] 
                    } 
                ] 
            }, 
            // Technical Solutions 
            { 
                type: "text", 
                content: "TECHNICAL SOLUTIONS", 
                alignment: "left", 
                fontSize: "text-3xl", 
                color: "#59cbff", 
                marginBottom: "mb-2" 
            }, 
            // Day Progression System 
            { 
                type: "two-column", 
                columns: [ 
                    { 
                        type: "text", 
                        width: "w-full lg:w-1/2", 
                        lines: [ 
                            { 
                                content: "DAY PROGRESSION SYSTEM", 
                                fontSize: "text-2xl", 
                                color: "#6fb2ff", 
                                alignment: "left" 
                            }, 
                            { 
                                content: "The entire game loop is organized around a structured day progression system. " + 
                                "Each completed day produces a snapshot containing player state, inventory, economy data and performance statistics.", 
                                fontSize: "text-xl", 
                                color: "#595959", 
                                alignment: "left" 
                            }, 
                            { 
                                content: "Completed days form a persistent run history that allows the player to restart from any previously completed milestone while maintaining progression consistency.", 
                                fontSize: "text-xl", 
                                color: "#595959", 
                                alignment: "left" 
                            } 
                        ] 
                    }, 
                    { 
                        type: "image", 
                        width: "w-full lg:w-1/2", 
                        position: "right", 
                        images: [ 
                            { 
                                src: "images/projects/working-title/day_progression.gif", 
                                alt: "day_progression.gif" 
                            } 
                        ] 
                    } 
                ] 
            }, 
            // Procedural Generation 
            { 
                type: "two-column", 
                columns: [ 
                    { 
                        type: "image", 
                        width: "w-full lg:w-1/2", 
                        position: "right", 
                        images: [ 
                            { 
                                src: "images/projects/working-title/procedural_generation.gif", 
                                alt: "procedural_generation.gif" 
                            } 
                        ] 
                    }, 
                    { 
                        type: "text", 
                        width: "w-full lg:w-1/2", 
                        lines: [ 
                            { 
                                content: "PROCEDURAL CITY GENERATION", 
                                fontSize: "text-2xl", 
                                color: "#6fb2ff", 
                                alignment: "left" 
                            }, 
                            { 
                                content: "Street levels are generated dynamically using a tile-based procedural generation system. " + 
                                "The generator creates traversable layouts and provides valid placement locations for gameplay objects.", 
                                fontSize: "text-xl", 
                                color: "#595959", 
                                alignment: "left" 
                            }, 
                            { 
                                content: "Object placement is separated from map generation, allowing stores, enemies, interaction points and distribution locations to be spawned independently from terrain generation.", 
                                fontSize: "text-xl", 
                                color: "#595959", 
                                alignment: "left" 
                            } 
                        ] 
                    } 
                ] 
            }, 
            // Architecture Overview 
            { 
                type: "text", 
                content: "GAMEPLAY ARCHITECTURE OVERVIEW", 
                alignment: "left", 
                fontSize: "text-3xl", 
                color: "#6fb2ff", 
                marginBottom: "mb-2" 
            }, 
            { 
                type: "hero-image", 
                src: "images/projects/working-title/architecture_overview.png", 
                alt: "architecture_overview.png" 
            }, 
            // State Management 
            { 
                type: "two-column", 
                columns: [ 
                    { 
                        type: "text", 
                        width: "w-full lg:w-1/2", 
                        lines: [ 
                            { 
                                content: "STATE MANAGEMENT", 
                                fontSize: "text-2xl", 
                                color: "#6fb2ff", 
                                alignment: "left" 
                            }, 
                            { 
                                content: "The project uses a centralized GameManager that coordinates scene transitions and persistent gameplay systems.", 
                                fontSize: "text-xl", 
                                color: "#595959", 
                                alignment: "left" 
                            }, 
                            { 
                                content: "Dedicated managers handle progression, economy, timing, encounters and save operations. " + 
                                "This separation of responsibilities reduces coupling and simplifies future expansion.", 
                                fontSize: "text-xl", 
                                color: "#595959", 
                                alignment: "left" 
                            } 
                        ] 
                    }, 
                    { 
                        type: "image", 
                        width: "w-full lg:w-1/2", 
                        position: "right", 
                        images: [ 
                            { 
                                src: "images/projects/working-title/state_management.png", 
                                alt: "state_management.png" 
                            } 
                        ] 
                    } 
                ] 
            }, 
            // Inventory & Economy 
            { 
                type: "two-column", 
                columns: [ 
                    { 
                        type: "image", 
                        width: "w-full lg:w-1/2", 
                        position: "right", 
                        images: [ 
                            { 
                                src: "images/projects/working-title/inventory_system.gif", 
                                alt: "inventory_system.gif" 
                            } 
                        ] 
                    }, 
                    { 
                        type: "text", 
                        width: "w-full lg:w-1/2", 
                        lines: [ 
                            { 
                                content: "INVENTORY & ECONOMY SYSTEMS", 
                                fontSize: "text-2xl", 
                                color: "#6fb2ff", 
                                alignment: "left" 
                            }, 
                            { 
                                content: "The player manages a persistent inventory that travels across gameplay scenes and interacts with home storage systems.", 
                                fontSize: "text-xl", 
                                color: "#595959", 
                                alignment: "left" 
                            }, 
                            { 
                                content: "The economy layer tracks earnings, purchases, rent payments and daily financial performance. " + 
                                "All item definitions are data-driven and implemented using ScriptableObjects.", 
                                fontSize: "text-xl", 
                                color: "#595959", 
                                alignment: "left" 
                            } 
                        ] 
                    } 
                ] 
            }, 
            // Survival Systems 
            { 
                type: "two-column", 
                columns: [ 
                    { 
                        type: "text", 
                        width: "w-full lg:w-1/2", 
                        lines: [ 
                            { 
                                content: "SURVIVAL & CHARACTER SYSTEMS", 
                                fontSize: "text-2xl", 
                                color: "#6fb2ff", 
                                alignment: "left" 
                            }, 
                            { 
                                content: "Player survival depends on managing multiple interconnected systems including health, hunger, craving and character statistics.", 
                                fontSize: "text-xl", 
                                color: "#595959", 
                                alignment: "left" 
                            }, 
                            { 
                                content: "Needs continuously evolve during gameplay and create pressure on both tactical decisions and long-term planning.", 
                                fontSize: "text-xl", 
                                color: "#595959", 
                                alignment: "left" 
                            } 
                        ] 
                    }, 
                    { 
                        type: "image", 
                        width: "w-full lg:w-1/2", 
                        position: "right", 
                        images: [ 
                            { 
                                src: "images/projects/working-title/survival_systems.gif", 
                                alt: "survival_systems.gif" 
                            } 
                        ] 
                    } 
                ] 
            }, 
            // GitHub 
            { 
                type: "github-link", 
                url: "https://github.com/yourusername/project", 
                text: "View source code on GitHub", 
                alignment: "center" 
            } 
        ]
    },
    // Distance
    {
        id: 9,
        slug: "distance",
        title: "DISTANCE",
        description: "A naive work inspired by the war in the Middle East, which is an interactive urban landscape whose appearance changes based on user input",
        tags: ["#unity", "#CSharp", "#2D", "#2DArt", "#digitalInstallation", "#art"],
        
        portfolioLayout: {
            type: "two-column",
            columns: [
                {
                    type: "text",
                    width: "w-full lg:w-2/3",
                    content: {
                        showTitle: true,
                        showDescription: true,
                        showTags: true
                    }
                },
                {
                    type: "image",
                    width: "w-full lg:w-1/3",
                    images: [
                        {
                            src: "/images/projects/distance/preview.gif",
                            alt: "Distance preview"
                        }
                    ]
                }
            ]
        },
        
        projectPageContent: [
            {   
                        type: "hero-image",
                        src: "/images/projects/distance/game-controls.png", 
                        alt: "game-controls" 
            },
            {
                type: "webgl",
                buildPath: "/webgl-builds/distance",
                buildName: "Distance_v1",
                width: "100%",
                height: "600px",
                mobileFallback: {
                    src: "/images/projects/distance/preview.gif",
                    alt: "Distance preview"
                }
            },
            {
                type: "image-gallery",
                images: [
                    { src: "/images/projects/distance/sprite-sheet1.jpg", alt: "sprite-sheet 1" },
                    { src: "/images/projects/distance/sprite-sheet2.jpg", alt: "sprite-sheet 2" },
                    { src: "/images/projects/distance/sprite-sheet3.jpg", alt: "sprite-sheet 3" }
                ]
            },
        ]
    },
    // Maze
    {
        id: 10,
        slug: "maze",
        title: "MAZE",
        description: "A digital installation that creates an immersive abstract environment reflecting emotional and informational overload in the modern world",
        tags: ["#unity", "#CSharp", "#3D", "#digitalInstallation", "#art"],
        
        portfolioLayout: {
            type: "two-column",
            columns: [
                
                {
                    type: "image",
                    width: "w-full lg:w-1/3",
                    images: [
                        {
                            src: "/images/projects/maze/preview.gif",
                            alt: "Maze preview"
                        }
                    ]
                },
                {
                    type: "text",
                    width: "w-full lg:w-2/3",
                    content: {
                        showTitle: true,
                        showDescription: true,
                        showTags: true
                    }
                }
            ]
        },
        
        projectPageContent: [
            {
                type: "local-video",
                src: "/video/maze_demo.mp4",
                title: "Maze Demo" 
            },
            {
                type: "two-column",
                columns: [
                    {
                        type: 'text',
                        width: 'w-full lg:w-1/2',
                        lines: [
                            {
                                content: 'The labyrinth is built from modular wall segments (straight, corners, dead-end variants), each containing trigger colliders that detect player proximity. ' +
                    'When the player enters a wall’s trigger zone, text elements are procedurally instantiated along the wall surface based on its orientation and length',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                            {
                                content: 'Text objects are generated from a predefined phrase pool with randomized font size and content, creating visual variation while reusing the same structural logic. '
                                + 'When the player exits the trigger area, the associated text instances are removed, ensuring that only nearby segments remain active at any time',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                            {
                                content: 'This proximity-driven spawning system allows the environment to maintain a constant perceived density of textual walls around the player while keeping the actual number of active objects low, reducing rendering overhead and simplifying scene management',
                                fontSize: 'text-xl',
                                color: "#595959",
                                alignment: 'left'
                            },
                        ]
                    },
                    {
                        type: 'image',
                        width: 'w-full lg:w-1/2',
                        position: 'right',
                        images: [
                            {
                                src: 'images/projects/maze/level_demo.png',
                                alt: 'level_demo.png'
                            }
                        ]
                    },
                ]
            },
        ]
    },
    */
   //#endregion
];

export const getAllTags = () => {
    const tagsSet = new Set();
    projects.forEach(project => {
        project.tags.forEach(tag => tagsSet.add(tag));
    });
    return Array.from(tagsSet).sort();
};

export const formatText = (text) => {
    if (!text) return null;
    return text.split('\n').map((line, index, arr) => (
        <span key={index}>
            {line}
            {index < arr.length - 1 && <br />}
        </span>
    ));
};